import React from 'react';
import OLYWebPageComponent from '../OLYWebPageComponent';
import { translate } from 'react-i18next';
import { withStyles } from '../../../node_modules/material-ui';
import PaymentsTable from './PaymentsTable';
import { Grid } from 'material-ui';


const styles = theme => ({
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: 'var(--secondary-button-color)',
    },
    myDropZone: {
        position: 'relative',
        height: '80px',
        borderStyle: 'dashed',
        borderWidth: '2px',
        borderRadius: '5px',
        textAlign: 'center'
    },
    activeDropZone: {
        borderStyle: 'solid',
        borderColor: '#6c6',
        backgroundColor: '#eee'
    },
    rejectedDropZone: {
        borderStyle: 'solid',
        borderColor: '#c66',
        backgroundColor: '#eee'
    }
});
class PendingPayments extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this.pageName = 'PaymentsWithoutReservation';
    }

    render() {
        const { t } = this.props;

        return (
            <div>
                <Grid container direction="row" justify="space-between" alignItems="center">
                    <Grid item xs={6}>
                        <h2 style={{ marginLeft: 20 }}>{t('PENDING_PAYMENTS.PAYMENTS_WITHOUT_RESERVATION')}</h2>
                    </Grid>
                    <Grid item xs={6}>
                        <span>{t('PENDING_PAYMENTS.POSIBLE_NOT_GUARANTEE')}</span>
                    </Grid>
                </Grid>  

                <PaymentsTable/>
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(PendingPayments));


// WEBPACK FOOTER //
// ./src/components/Payments/PendingPayments.js